import type { MigrationTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const migrationUr: MigrationTranslation = {
  nav: 'پرانی گفتگو درآمد کریں',
  title: 'کسی دوسرے ٹول سے درآمد کریں',
  description:
    'اپنی پچھلی سپورٹ گفتگو Hamnivo میں لائیں۔ جس ٹول کو آپ ابھی استعمال کرتے ہیں اس میں کچھ نہیں بدلتا۔',
  newImport: 'نئی درآمد',
  exportHistory: 'تاریخ برآمد کریں',
  loading: 'درآمدات لوڈ ہو رہی ہیں',
  noBrands: 'درآمد سے پہلے ایک برانڈ شامل کریں اور اسے Chatwoot سے جوڑیں۔',
  list: {
    title: 'درآمدات اور برآمدات',
    empty: {
      title: 'ابھی کوئی درآمد نہیں',
      description:
        'tawk.to، Zendesk، Intercom یا Hamnivo کی ایکسپورٹ اپ لوڈ کریں، یا کوئی دوسرا Chatwoot جوڑیں۔ کچھ بھی درآمد ہونے سے پہلے آپ دیکھیں گے کہ اس میں کیا ہے۔',
    },
    columns: {
      file: 'فائل',
      kind: 'قسم',
      brand: 'برانڈ',
      state: 'حالت',
      conversations: 'گفتگو',
      started: 'شروع ہوئی',
    },
    open: '{{name}} کھولیں',
    importKind: '{{source}} سے درآمد',
    exportKind: 'برآمد',
    of: '{{total}} میں سے {{done}}',
  },
  back: 'تمام درآمدات',
  steps: {
    label: 'درآمد کے مراحل',
    source: 'ذریعہ',
    sourceHint: 'ایکسپورٹ فائل',
    check: 'جانچ',
    checkHint: 'فیلڈز اور سیٹنگز',
    sample: 'نمونہ دیکھیں',
    sampleHint: 'جانچیں اور تصدیق کریں',
    import: 'درآمد',
    importHint: 'چلائیں اور دیکھیں',
    done: 'مکمل',
    current: 'موجودہ مرحلہ',
  },
  sources: {
    'tawk.to': 'tawk.to',
    hamnivo: 'Hamnivo پیکج',
    chatwoot: 'Chatwoot',
    intercom: 'Intercom',
    zendesk: 'Zendesk',
  },
  state: {
    scanning: 'فائل جانچی جا رہی ہے',
    rejected: 'فائل مسترد',
    blocked: 'توجہ درکار',
    ready: 'جانچ ہو گئی',
    dry_running: 'گنتی ہو رہی ہے',
    dry_run_ready: 'درآمد کے لیے تیار',
    queued: 'شروع ہونے کا انتظار',
    running: 'درآمد ہو رہی ہے',
    paused: 'رکی ہوئی',
    cancelled: 'منسوخ',
    completed: 'مکمل',
    failed: 'رک گئی',
    rolling_back: 'ہٹائی جا رہی ہے',
    rolled_back: 'ہٹا دی گئی',
    closed: 'منظور',
  },
  upload: {
    title: 'درآمد شروع کریں',
    description: 'منتخب کریں کہ ایکسپورٹ کہاں سے ہے اور اسے اپ لوڈ کریں۔ ابھی کچھ درآمد نہیں ہوگا۔',
    brand: 'کس برانڈ میں درآمد کریں',
    brandRequired: 'ایک برانڈ منتخب کریں۔',
    source: 'ایکسپورٹ کہاں سے ہے',
    sourceHints: {
      'tawk.to': 'tawk.to میں “Export chats” سے ملنے والی ZIP یا JSON فائلیں۔',
      zendesk:
        'Zendesk کی مکمل JSON ایکسپورٹ کی ZIP۔ نام درآمد کرنے کے لیے صارفین کی ایکسپورٹ اسی ZIP میں شامل کریں۔',
      intercom: 'گفتگو اسی شکل میں جیسے Intercom API دیتی ہے، JSON یا NDJSON فائلوں میں۔',
      hamnivo: 'Hamnivo سے برآمد کیا گیا یا Hamnivo فارمیٹ میں بنا پیکج۔',
      chatwoot: 'کوئی دوسرا Chatwoot اکاؤنٹ، اس کے کسی صارف کے رسائی ٹوکن سے پڑھا جاتا ہے۔',
    },
    file: 'ایکسپورٹ فائل',
    fileHint: 'ZIP، JSON یا NDJSON، 20 MB تک۔ پڑھنے سے پہلے اس میں میل ویئر کی جانچ ہوتی ہے۔',
    fileChosen: 'منتخب: {{name}} ({{size}})',
    fileRequired: 'ایکسپورٹ فائل منتخب کریں۔',
    fileType: 'ZIP، JSON یا NDJSON فائل منتخب کریں۔',
    fileTooLarge: 'یہ فائل {{size}} کی ہے۔ ایکسپورٹ 20 MB تک ہو سکتی ہے۔',
    chatwoot: {
      url: 'Chatwoot کا پتا',
      urlHint: 'مثال: https://chat.example.com',
      urlRequired: 'جس Chatwoot سے درآمد کرنی ہے اس کا پتا لکھیں۔',
      account: 'اکاؤنٹ ID',
      accountHint: 'اس Chatwoot کے ایڈریس بار میں ‎/accounts/‎ کے بعد والا نمبر۔',
      accountInvalid: 'اکاؤنٹ نمبر لکھیں۔',
      token: 'رسائی ٹوکن',
      tokenHint:
        'اس Chatwoot کی پروفائل سیٹنگز سے۔ ایڈمن کا ٹوکن ہر ان باکس پڑھتا ہے۔ یہ ایک بار استعمال ہوتا ہے، پھر مٹا دیا جاتا ہے۔',
      tokenRequired: 'رسائی ٹوکن لکھیں۔',
      inboxes: 'ان باکس IDs',
      inboxesHint: 'صرف یہ ان باکس، کوما سے الگ۔ سب کے لیے خالی چھوڑیں۔',
      inboxesInvalid: 'کوما سے الگ ان باکس نمبر لکھیں۔',
      submit: 'جوڑیں اور جانچیں',
    },
    privacy:
      'اس برانڈ کی درآمدات سنبھالنے والے لوگ ہی فائل دیکھ سکتے ہیں۔ درآمد منظور ہونے یا ہٹائے جانے پر فائل مٹا دی جاتی ہے۔',
    submit: 'اپ لوڈ کریں اور جانچیں',
    uploaded: '{{name}} اپ لوڈ ہو گئی۔ اب اس کی جانچ ہو رہی ہے۔',
  },
  file: {
    uploaded: '{{time}} کو اپ لوڈ · {{size}}',
    read: '{{time}} کو پڑھا · {{size}}',
    into: '{{brand}} میں',
    purged: 'فائل مٹا دی گئی۔ گنتی اور رپورٹیں باقی رہتی ہیں۔',
    change: 'دوسری فائل اپ لوڈ کریں',
  },
  scanning: {
    title: 'فائل جانچی جا رہی ہے',
    description: 'ہم اس میں میل ویئر کی جانچ کرتے ہیں اور اسے پڑھتے ہیں۔ ابھی کچھ درآمد نہیں ہوا۔',
    apiTitle: 'Chatwoot سے پڑھا جا رہا ہے',
    apiDescription:
      'ہم گفتگو اور فائلیں پڑھتے ہیں، پھر ان میں میل ویئر کی جانچ کرتے ہیں۔ ابھی کچھ درآمد نہیں ہوا۔',
  },
  rejected: {
    title: 'یہ فائل درآمد نہیں ہو سکتی',
    reasons: {
      malware: 'میل ویئر اسکینر کو اس فائل میں خطرہ ملا۔ فائل مٹا دی گئی۔',
      scan_unavailable: 'میل ویئر اسکینر فائل کی جانچ نہیں کر سکا۔ چند منٹ بعد دوبارہ کوشش کریں۔',
      not_supported: 'یہ ایسی ایکسپورٹ نہیں جسے ہم پڑھ سکیں۔ ZIP یا JSON ایکسپورٹ فائل منتخب کریں۔',
      truncated:
        'فائل بیچ میں ختم ہو جاتی ہے۔ شاید ڈاؤن لوڈ مکمل نہیں ہوا۔ ایکسپورٹ دوبارہ ڈاؤن لوڈ کریں۔',
      corrupt: 'فائل خراب ہے اور پڑھی نہیں جا سکتی۔ ایکسپورٹ دوبارہ ڈاؤن لوڈ کریں۔',
      too_large: 'فائل کھل کر ہماری حد سے بڑی ہو جاتی ہے۔ ایکسپورٹ کو چھوٹی فائلوں میں تقسیم کریں۔',
      too_many_files: 'آرکائیو میں بہت زیادہ فائلیں ہیں۔ ایکسپورٹ کو چھوٹی فائلوں میں تقسیم کریں۔',
      unsafe_path: 'آرکائیو میں ایک فائل کا نام محفوظ نہیں۔',
      not_utf8: 'فائل UTF-8 متن نہیں ہے۔',
      source_denied:
        'ٹوکن یہ اکاؤنٹ نہیں پڑھ سکتا۔ اکاؤنٹ ID جانچیں، اور اس کے کسی ایڈمن کا ٹوکن استعمال کریں۔',
      source_unreachable: 'اس Chatwoot تک نہیں پہنچا جا سکا۔ پتا جانچیں اور دوبارہ کوشش کریں۔',
      private_address: 'یہ پتا ایک نجی نیٹ ورک کے اندر ہے، جہاں درآمد نہیں پہنچ سکتی۔',
      insecure_url: 'پتا https:// سے شروع ہونا چاہیے۔',
      invalid_url: 'یہ پتا درست نہیں۔',
      unresolved: 'یہ پتا نہیں ملا۔',
      empty: 'فائل خالی ہے۔',
      other: 'فائل پڑھی نہیں جا سکی۔',
    },
  },
  preflight: {
    title: 'ایکسپورٹ میں کیا ہے',
    description: 'صرف گنتی اور فیلڈز کے نام۔ کچھ بھی درآمد نہیں ہوا۔',
    counts: {
      conversations: 'گفتگو',
      messages: 'پیغامات',
      internalNotes: 'اندرونی نوٹس',
      contacts: 'لوگ',
      attachments: 'فائلیں',
      attachmentFiles: 'شامل فائلیں',
    },
    declared: 'ایکسپورٹ کے مطابق اس میں {{conversations}} گفتگو اور {{messages}} پیغامات ہیں۔',
    truncated: 'ایکسپورٹ کا کچھ حصہ غائب ہے',
    truncatedHint:
      'اس ایکسپورٹ میں کچھ گفتگو نامکمل ہیں۔ وہ نیچے دی گئی ہیں۔ جو موجود ہے اسے درآمد کریں، یا پہلے دوبارہ ایکسپورٹ کریں۔',
    detected: 'یہ فائل {{source}} کی ایکسپورٹ لگتی ہے۔ دوبارہ شروع کریں اور {{source}} منتخب کریں۔',
    checks: {
      title: 'درآمد سے پہلے',
      status: { ok: 'تیار', warning: 'جانچیں', blocked: 'رکاوٹ' },
      codes: {
        authority_connected: {
          ok: 'اس برانڈ کے لیے Chatwoot جڑا ہوا ہے۔',
          blocked: 'پہلے اس برانڈ کو Chatwoot سے جوڑیں (برانڈز اور انسٹال)۔',
        },
        import_inbox: {
          ok: 'درآمد شدہ گفتگو اپنے الگ ان باکس میں جاتی ہے، جوابات، بوٹس، اسائنمنٹ یا سروے کے بغیر۔',
          will_create:
            'درآمد شدہ گفتگو کے لیے پہلی درآمد پر ایک ان باکس بنتا ہے۔ وہ کبھی جواب، اسائنمنٹ یا سروے نہیں بھیجتا۔',
          blocked:
            'درآمد والے ان باکس میں ایسی سیٹنگز ہیں جو لوگوں کو اطلاع بھیج سکتی ہیں: {{detail}}۔ انہیں Chatwoot میں بند کریں، پھر دوبارہ جانچیں۔',
        },
        authority_admin: {
          ok: 'Hamnivo وہ Chatwoot سیٹنگز پڑھ سکتا ہے جن کی اسے جانچ کرنی ہے۔',
          blocked:
            'Hamnivo Chatwoot کی سیٹنگز نہیں پڑھ سکتا۔ اس برانڈ کے لیے Chatwoot دوبارہ جوڑیں۔',
        },
        automations: {
          ok: 'کوئی Chatwoot آٹومیشن درآمد شدہ گفتگو پر کام نہیں کرتی۔',
          blocked:
            '{{detail}} Chatwoot آٹومیشنز درآمد شدہ گفتگو پر کام کریں گی۔ انہیں بند کریں یا درآمد والا ان باکس الگ رکھیں، پھر دوبارہ جانچیں۔',
        },
        integrations: {
          ok: 'کسی انٹیگریشن کو درآمد شدہ پیغامات نہیں ملتے۔',
          blocked:
            'ان انٹیگریشنز کو درآمد شدہ پیغامات ملیں گے: {{detail}}۔ انہیں بند کریں، پھر دوبارہ جانچیں۔',
        },
        authority_unreachable: {
          ok: 'Chatwoot تک پہنچا جا سکتا ہے۔',
          blocked: 'ابھی Chatwoot تک نہیں پہنچا جا سکتا۔ چند منٹ بعد دوبارہ کوشش کریں۔',
        },
        source_access: {
          ok: 'ٹوکن اکاؤنٹ کا ہر ان باکس پڑھ سکتا ہے۔',
          blocked: 'ٹوکن کسی ایڈمن کا نہیں: صرف وہی ان باکس پڑھے جاتے ہیں جو اسے نظر آتے ہیں۔',
        },
        source_mismatch: {
          ok: 'فائل آپ کے منتخب ذریعے سے ملتی ہے۔',
          blocked: 'فائل آپ کے منتخب ذریعے سے نہیں ملتی۔',
        },
      },
      settings: {
        webhook: 'ویب ہک',
        agent_bot: 'بوٹ',
        auto_assignment: 'خودکار اسائنمنٹ',
        greeting: 'خوش آمدید پیغام',
        csat: 'اطمینان سروے',
        working_hours: 'کام کے اوقات کے پیغامات',
        single_conversation: 'ہر شخص کی ایک گفتگو',
      },
    },
    fields: {
      title: 'فیلڈز',
      description:
        'فائل کا ہر فیلڈ کیسے درآمد ہوتا ہے۔ جو فیلڈز درآمد نہیں ہوتے وہ یہاں دکھائے جاتے ہیں، خاموشی سے ہٹائے نہیں جاتے۔',
      columns: {
        source: 'فائل میں فیلڈ',
        target: 'کیا بنتا ہے',
        status: 'حالت',
        found: 'کہاں ملا',
      },
      status: {
        supported: 'درآمد ہوتا ہے',
        transformed: 'درآمد پر بدلا جاتا ہے',
        unsupported: 'درآمد نہیں ہوتا',
      },
      required: 'ضروری',
      records: '{{count}} ریکارڈ',
      showUnsupported: 'درآمد نہ ہونے والے {{fields}} فیلڈز دکھائیں',
      hideUnsupported: 'درآمد نہ ہونے والے فیلڈز چھپائیں',
      same: 'جیسا ہے ویسا رہتا ہے',
      none: '—',
      targets: {
        'conversation.source_id': 'گفتگو کی ID',
        'conversation.kind': 'گفتگو کی قسم',
        'conversation.started_at': 'شروع ہونے کا وقت',
        'conversation.completeness_check': 'مکمل ہونے کی جانچ',
        'conversation.attribute': 'گفتگو کی تفصیل',
        'message.original_time': 'پیغام کا اصل وقت',
        'message.text': 'پیغام کا متن',
        'message.kind': 'پیغام کی قسم',
        'message.author': 'بھیجنے والا',
        'message.author_name': 'بھیجنے والے کا نام',
        'message.author_source_id': 'بھیجنے والے کی ID',
        'attachment.link': 'فائل کا لنک',
        'contact.source_id': 'شخص کی ID',
        'contact.name': 'نام',
        'contact.unverified_email': 'ای میل، غیر تصدیق شدہ کے طور پر رکھی جاتی ہے',
        'contact.unverified_phone': 'فون، غیر تصدیق شدہ کے طور پر رکھا جاتا ہے',
        'contact.location': 'مقام',
        'conversation.status': 'حالت',
        'conversation.labels': 'لیبلز',
        'conversation.assignee': 'ذمہ دار شخص',
        'conversation.team': 'ٹیم',
        'message.visibility': 'نجی یا عوامی',
        'attachment.file': 'فائل',
        'contact.attribute': 'شخص کی تفصیل',
        'contact.identifier': 'شناخت کنندہ',
        'conversation.subject': 'موضوع',
        'conversation.channel': 'چینل',
        'message.source_id': 'پیغام ID',
        'message.formatting': 'فارمیٹنگ',
      },
    },
    missing: {
      title: 'ایک ضروری فیلڈ غائب ہے',
      description:
        'اس ایکسپورٹ میں “{{field}}” نہیں ہے۔ اس کے بغیر گفتگو درآمد نہیں ہو سکتی۔ اسے شامل کر کے دوبارہ ایکسپورٹ کریں۔',
    },
    limits: {
      title: '{{source}} کی معلوم حدود',
      codes: {
        tawk_export_cap:
          'tawk.to ایک وقت میں 50 چیٹس تک ایکسپورٹ کرتا ہے۔ ہر ضروری مدت ایکسپورٹ کریں اور ہر فائل درآمد کریں۔',
        tawk_rest_approval:
          'tawk.to API سے براہِ راست درآمد کے لیے tawk.to کی منظوری چاہیے، اس لیے درآمد ایکسپورٹ کی گئی فائلوں سے ہوتی ہے۔',
        tawk_attachment_links:
          'ایکسپورٹ میں فائلوں کے لنک ہوتے ہیں، فائلیں نہیں۔ فائلیں درآمد نہ ہونے والی فہرست میں دکھائی جاتی ہیں۔',
        tawk_tickets: 'ٹکٹس اور آف لائن پیغامات درآمد نہیں ہوتے۔',
        tawk_no_notes: 'tawk.to کی ایکسپورٹ میں اندرونی نوٹس نہیں ہوتے۔',
        tawk_unverified_email:
          'ای میلز وزیٹرز نے خود لکھی تھیں۔ انہیں حوالے کے لیے رکھا جاتا ہے، لوگوں کو ملانے کے لیے کبھی نہیں۔',
        chatwoot_snapshot_cap:
          'ایک درآمد مقررہ تعداد میں گفتگو پڑھتی ہے، سب سے پرانی پہلے۔ آگے بڑھنے کے لیے اسے دوبارہ چلائیں: درآمد ہو چکی گفتگو دوبارہ نہیں پڑھی جاتی۔',
        chatwoot_agent_scope: 'ایجنٹ کا ٹوکن صرف اسی ایجنٹ کے ان باکس پڑھتا ہے۔',
        chatwoot_activity: 'سرگرمی کے پیغامات (حالت کی تبدیلی، اسائنمنٹ) درآمد نہیں ہوتے۔',
        chatwoot_unverified_contacts:
          'ای میلز اور فون نمبر غیر تصدیق شدہ کے طور پر رکھے جاتے ہیں؛ لوگوں کو ان سے کبھی نہیں ملایا جاتا۔',
        chatwoot_token_once:
          'ٹوکن اکاؤنٹ پڑھنے کے لیے ایک بار استعمال ہوتا ہے، پھر Hamnivo سے مٹا دیا جاتا ہے۔ بعد میں اسے Chatwoot میں منسوخ کریں۔',
        zendesk_large_tickets:
          'Zendesk ان ٹکٹس کے تبصرے ایکسپورٹ نہیں کرتا جو 1 MB سے بڑے ہوں۔ ایسے ٹکٹس نامکمل کے طور پر دکھائے جاتے ہیں اور درآمد نہیں ہوتے۔',
        zendesk_users_export:
          'صارفین کی ایکسپورٹ اسی ZIP میں شامل کریں۔ اس سے نام ملتے ہیں اور گاہکوں اور ٹیم کے ارکان میں فرق ہوتا ہے۔ اس کے بغیر نامعلوم لوگوں کے تبصرے درآمد نہیں ہوتے۔',
        zendesk_attachment_links:
          'ایکسپورٹ میں فائلوں کے لنک ہوتے ہیں، فائلیں نہیں۔ فائلیں درآمد نہ ہونے والی فہرست میں دکھائی جاتی ہیں۔',
        zendesk_history: 'ٹکٹ کی تاریخ، سائیڈ گفتگو اور حسبِ ضرورت فیلڈز درآمد نہیں ہوتے۔',
        zendesk_unverified_contacts:
          'ای میلز اور فون نمبر غیر تصدیق شدہ کے طور پر رکھے جاتے ہیں؛ لوگوں کو ان سے کبھی نہیں ملایا جاتا۔',
        intercom_api_format:
          'Intercom میں پیغامات کے متن والی کوئی ایکسپورٹ فائل نہیں۔ گفتگو اسی شکل میں اپ لوڈ کریں جیسے اس کی API دیتی ہے۔',
        intercom_parts_cap:
          'Intercom کی API کسی گفتگو کے زیادہ سے زیادہ آخری 500 حصے دیتی ہے۔ لمبی گفتگو سب سے پرانے حصوں کے بغیر درآمد ہوتی ہے اور نامکمل کے طور پر دکھائی جاتی ہے۔',
        intercom_events: 'اسائنمنٹ، حالت کی تبدیلیاں اور دوسرے واقعات درآمد نہیں ہوتے۔',
        intercom_plain_text:
          'پیغامات سادہ متن کے طور پر درآمد ہوتے ہیں۔ فارمیٹنگ اور اندر لگی تصاویر شامل نہیں ہوتیں۔',
        intercom_attachment_links:
          'گفتگو میں فائلوں کے لنک ہوتے ہیں، فائلیں نہیں۔ فائلیں درآمد نہ ہونے والی فہرست میں دکھائی جاتی ہیں۔',
        intercom_unverified_contacts:
          'ای میلز اور فون نمبر غیر تصدیق شدہ کے طور پر رکھے جاتے ہیں؛ لوگوں کو ان سے کبھی نہیں ملایا جاتا۔',
        package_links_only: 'صرف لنک کے طور پر دی گئی فائلیں درآمد نہیں ہوتیں۔',
      },
    },
    issues: {
      title: 'ریکارڈ جنہیں دیکھنا ضروری ہے',
      none: 'ہر ریکارڈ درآمد ہو سکتا ہے۔',
      count: '{{count}} ریکارڈ',
      examples: 'مثال: {{ids}}',
      error: 'درآمد نہیں ہو سکتا',
      warning: 'جانچیں',
    },
    recheck: 'دوبارہ جانچیں',
    next: 'نمونہ دیکھیں',
    blocking: '“رکاوٹ” والی چیزیں ٹھیک کریں، پھر دوبارہ جانچیں۔',
    cancel: 'درآمد منسوخ کریں',
    cancelTitle: 'یہ درآمد منسوخ کریں؟',
    cancelBody: 'کچھ بھی درآمد نہیں ہوا۔ اپ لوڈ کی گئی فائل مٹا دی جاتی ہے۔',
    cancelled: 'درآمد منسوخ ہو گئی۔',
  },
  reasons: {
    duplicate_existing: 'پہلے سے درآمد شدہ',
    duplicate_in_file: 'فائل میں ایک سے زیادہ بار',
    invalid_record: 'درست ریکارڈ نہیں',
    missing_time: 'وقت موجود نہیں',
    unsupported_type: 'یہ قسم معاون نہیں',
    unsupported_sender: 'یہ بھیجنے والا معاون نہیں',
    missing_conversation: 'اس کی گفتگو غائب ہے',
    missing_contact: 'اس کا شخص غائب ہے',
    empty_message: 'درآمد کرنے کو کچھ نہیں',
    missing_attachment: 'فائل ایکسپورٹ میں نہیں',
    binary_not_in_export: 'صرف لنک ہے، فائل ایکسپورٹ میں نہیں',
    checksum_mismatch: 'فائل خراب (چیک سم مختلف)',
    type_mismatch: 'فائل کی قسم کی اجازت نہیں یا دعوے سے مختلف',
    too_large: 'بہت بڑی',
    malware: 'میل ویئر ملا',
    scan_unavailable: 'جانچ نہیں ہو سکی',
    authority_rejected: 'Chatwoot نے مسترد کیا',
    authority_unavailable: 'Chatwoot دستیاب نہیں تھا',
    parent_failed: 'اس کی گفتگو درآمد نہیں ہوئی',
    not_referenced: 'کسی گفتگو میں استعمال نہیں',
    cancelled: 'پہلے ہی درآمد منسوخ ہوئی',
    truncated: 'ایکسپورٹ میں ادھورا',
    invalid_json: 'نہ پڑھی جانے والی سطر',
    truncated_file: 'فائل ادھوری',
    count_mismatch: 'فائل میں لکھے سے کم ریکارڈ',
    export_cap_reached: 'ایکسپورٹ شاید 50 چیٹس کی حد تک پہنچی',
    incomplete_package: 'پیکج کے مطابق وہ ادھورا ہے',
    no_conversations: 'کوئی گفتگو نہیں ملی',
    unknown_file: 'فائل پہچانی نہیں گئی',
  },
  kinds: {
    conversation: 'گفتگو',
    message: 'پیغامات',
    note: 'اندرونی نوٹس',
    contact: 'لوگ',
    attachment: 'فائلیں',
  },
  kind: {
    conversation: 'گفتگو',
    message: 'پیغام',
    contact: 'شخص',
    attachment: 'فائل',
  },
  dryRun: {
    title: 'نمونے کے نتائج',
    description: 'درآمد کیا کرے گی۔ کچھ بھی تبدیل نہیں ہوا۔',
    counting: 'گنا جا رہا ہے کہ درآمد کیا کرے گی…',
    ready: 'گفتگو تیار',
    readyHint: 'یہ درآمد ہوں گی۔',
    duplicates: 'ڈپلیکیٹ',
    duplicatesHint: 'پہلے سے درآمد شدہ۔ انہیں چھوڑ دیا جاتا ہے۔',
    review: 'دیکھنا ضروری',
    reviewHint: 'غائب یا غلط ڈیٹا۔ فہرست میں، درآمد نہیں۔',
    messages: '{{ready}} پیغامات، ان میں {{internal}} اندرونی نوٹس۔',
    people: 'تصدیق شدہ ID والے {{verified}} لوگ، بغیر ID کے {{unverified}}۔',
    peopleHint: 'لوگوں کو کبھی بھی لکھی گئی ای میل یا فون سے نہیں ملایا جاتا۔',
    files: '{{ready}} فائلیں تیار، {{review}} کو دیکھنا ضروری۔',
    truncated: 'یہ ایکسپورٹ ادھوری ہے۔ رپورٹ بتائے گی کہ کیا غائب ہے۔',
    duplicateChoice: 'ڈپلیکیٹ کا کیا کریں',
    duplicateSkip: 'موجودہ کو چھوڑیں',
    duplicateHint: 'پہلے سے درآمد شدہ گفتگو چھوڑ دی جاتی ہے۔ اصل ویسی ہی رہتی ہے۔',
    destination:
      'گفتگو {{brand}} میں درآمد ہوتی ہے۔ اس برانڈ تک رسائی والے لوگ ہی اسے دیکھ سکتے ہیں۔',
    nothingSent: 'درآمد کے دوران گاہکوں یا ساتھیوں کو کچھ نہیں بھیجا جاتا۔',
    report: 'جائزہ رپورٹ ڈاؤن لوڈ کریں',
    run: 'درآمد چلائیں',
    runTitle: '{{count}} گفتگو {{brand}} میں درآمد کریں؟',
    runBody:
      'گفتگو اپنا اصل وقت رکھتی ہے، اور اندرونی نوٹس نجی رہتے ہیں۔ آپ کسی بھی وقت روک یا منسوخ کر سکتے ہیں۔',
    runSubmit: 'درآمد شروع کریں',
    started: 'درآمد شروع ہو گئی۔',
    again: 'دوبارہ گنیں',
  },
  sample: {
    title: 'نمونہ گفتگو',
    description: 'فائل کی ایک گفتگو، جیسی وہ نظر آئے گی۔ ای میلز اور نمبر چھپائے گئے ہیں۔',
    choose: 'نمونہ',
    option: 'گفتگو {{number}}',
    loading: 'نمونہ لوڈ ہو رہا ہے',
    source: 'ایکسپورٹ میں',
    imported: 'Hamnivo میں',
    notYet: 'ابھی درآمد نہیں ہوئی۔',
    started: '{{time}} کو شروع',
    internal: 'اندرونی نوٹ',
    authors: { customer: 'گاہک', agent: 'ساتھی', bot: 'بوٹ', system: 'سسٹم' },
    noText: 'کوئی متن نہیں',
    originalTime: 'اصل وقت {{time}}',
    importedAt: '{{time}} کو درآمد',
    matches: 'ایکسپورٹ سے ملتی ہے',
    differs: 'ایکسپورٹ سے مختلف ہے',
    problems: {
      order_or_count: 'پیغامات غائب ہیں یا ترتیب مختلف ہے۔',
      original_time: 'ایک پیغام کا اصل وقت مختلف ہے۔',
      visibility: 'ایک پیغام کی مرئیت مختلف ہے۔',
    },
    unavailable: 'نمونے دستیاب نہیں: ایکسپورٹ فائل مٹا دی گئی۔',
  },
  progress: {
    title: 'درآمد کی پیش رفت',
    queued: 'شروع ہونے کا انتظار…',
    count: '{{total}} میں سے {{done}} گفتگو درآمد ہوئی',
    percent: '{{percent}} مکمل',
    checkpoint: '{{total}} میں سے گفتگو {{done}}، {{time}} کو محفوظ',
    closeHint: 'آپ یہ صفحہ بند کر سکتے ہیں۔ درآمد پس منظر میں جاری رہتی ہے۔',
    pausing: 'اگلے چیک پوائنٹ پر رکے گی…',
    cancelling: 'اگلے چیک پوائنٹ پر منسوخ ہوگی…',
    paused: '{{total}} میں سے گفتگو {{done}} پر رکی ہوئی۔',
    failed: 'درآمد رک گئی: {{reason}}۔ دوبارہ شروع کرنے پر یہ اپنے چیک پوائنٹ سے آگے چلتی ہے۔',
    errors: {
      authority_unavailable: 'Chatwoot دستیاب نہیں تھا',
      import_inbox_not_quiet:
        'درآمد والے ان باکس میں ایسی سیٹنگز ہیں جو لوگوں کو اطلاع بھیج سکتی ہیں',
      internal: 'ہماری طرف سے کچھ غلط ہوا',
      other: 'کچھ غلط ہوا',
    },
    pause: 'روکیں',
    resume: 'دوبارہ شروع کریں',
    cancel: 'درآمد منسوخ کریں',
    cancelTitle: 'یہ درآمد منسوخ کریں؟',
    cancelBody:
      'یہ اگلے چیک پوائنٹ پر رکتی ہے۔ درآمد ہو چکی گفتگو تب تک رہتی ہے جب تک آپ اسے ہٹائیں نہیں۔',
    pauseRequested: 'درآمد اگلے چیک پوائنٹ پر رکے گی۔',
    resumed: 'درآمد دوبارہ شروع ہو گئی۔',
    cancelRequested: 'درآمد اگلے چیک پوائنٹ پر رکے گی۔',
  },
  result: {
    completed: 'درآمد مکمل ہو گئی',
    completedIssues: 'درآمد کچھ مسائل کے ساتھ مکمل ہوئی',
    cancelled: 'درآمد منسوخ ہو گئی',
    rolledBack: 'درآمد ہٹا دی گئی',
    closed: 'درآمد منظور ہو گئی',
    finished: '{{time}} کو مکمل',
    approved: '{{time}} کو منظور',
    imported: 'گفتگو درآمد ہوئی',
    skipped: 'چھوڑی گئی (ڈپلیکیٹ)',
    notImported: 'درآمد نہیں ہوئی',
    failed: 'ناکام',
    downloadErrors: 'جو درآمد نہیں ہوا اسے ڈاؤن لوڈ کریں',
    retry: 'ناکام ریکارڈ دوبارہ آزمائیں',
    retryHint: 'صرف ناکام ریکارڈ دوبارہ بھیجے جاتے ہیں۔ درآمد ہو چکے ریکارڈ کبھی دہرائے نہیں جاتے۔',
    retried: 'ناکام ریکارڈ دوبارہ آزمائے جا رہے ہیں۔',
  },
  review: {
    title: 'مطابقت',
    description: 'ایکسپورٹ کا ہر ریکارڈ، اور اس کا کیا بنا۔',
    columns: {
      kind: 'ریکارڈ',
      discovered: 'ایکسپورٹ میں',
      imported: 'درآمد ہوئے',
      skipped: 'چھوڑے گئے',
      quarantined: 'درآمد نہیں ہوئے',
      failed: 'ناکام',
      pending: 'پہنچے نہیں',
      rolledBack: 'ہٹائے گئے',
    },
    missingFromExport:
      'ایکسپورٹ میں بتائے گئے مگر اس میں نہیں: {{messages}} پیغامات، {{conversations}} گفتگو۔',
    checks: {
      title: 'جانچیں',
      passed: 'کامیاب',
      failed: 'ناکام',
      codes: {
        all_accounted: 'ہر ریکارڈ درآمد ہوا یا اس کی وجہ درج ہے',
        no_failures: 'کسی ریکارڈ کی درآمد ناکام نہیں ہوئی',
        export_complete: 'ایکسپورٹ مکمل تھی',
        no_duplicates: 'کچھ بھی دو بار درآمد نہیں ہوا',
        private_kept_private: 'اندرونی نوٹس نجی رہے',
        nothing_sent: 'گاہکوں کو کچھ نہیں بھیجا گیا',
        sample_matches: 'نمونہ گفتگو ایکسپورٹ سے ملتی ہے',
        nothing_left: 'درآمد نے جو بنایا تھا وہ سب ہٹا دیا گیا',
      },
    },
    reasons: { title: 'ریکارڈ درآمد کیوں نہیں ہوئے', none: 'ہر ریکارڈ درآمد ہوا۔' },
    unsupported: {
      title: 'فیلڈز جو درآمد نہیں ہوئے',
      none: 'ہر فیلڈ درآمد ہوا۔',
      count: '{{count}} ریکارڈ',
    },
    quarantine: {
      title: 'ریکارڈ جو درآمد نہیں ہوئے',
      description: 'ہر ایک اپنی وجہ کے ساتھ۔ پوری فہرست اسپریڈشیٹ کے طور پر ڈاؤن لوڈ کریں۔',
      none: 'کوئی ریکارڈ رہ نہیں گیا۔',
      columns: {
        kind: 'قسم',
        id: 'ایکسپورٹ میں ID',
        conversation: 'گفتگو',
        reason: 'وجہ',
      },
      more: 'مزید دکھائیں',
      loading: 'ریکارڈ لوڈ ہو رہے ہیں',
    },
    samples: {
      title: 'نمونوں کا موازنہ',
      description: 'Chatwoot سے پڑھی گئی گفتگو، ایکسپورٹ کے ساتھ۔',
    },
    cutover: {
      title: 'درآمد منظور کریں',
      description: 'پرانا ٹول بند کرنے سے پہلے یہ جانچیں۔',
      checklist: {
        counts: 'گنتی آپ کی توقع سے ملتی ہے۔',
        samples: 'نمونہ گفتگو درست لگتی ہے۔',
        live: 'نئی گفتگو اب Hamnivo سے آتی ہے، اس لیے کچھ بھی دو بار درآمد نہیں ہوتا۔',
      },
      acknowledge: 'میں اوپر دی گئی ناکام جانچیں قبول کرتا/کرتی ہوں۔',
      acknowledgeRequired: 'تصدیق کریں کہ آپ ناکام جانچیں قبول کرتے ہیں۔',
      approve: 'درآمد منظور کریں',
      approved: 'درآمد منظور ہو گئی۔',
      rollbackWindow: 'منظوری دینے تک آپ اس درآمد سے بنی ہر چیز ہٹا سکتے ہیں۔',
    },
    rollback: {
      action: 'درآمد شدہ گفتگو ہٹائیں',
      title: 'اس درآمد نے جو بنایا اسے ہٹائیں؟',
      body: 'اس درآمد سے بنی گفتگو اور لوگ Chatwoot سے مٹا دیے جاتے ہیں۔ لائیو گفتگو اور کہیں اور استعمال ہونے والے لوگ باقی رہتے ہیں۔',
      submit: 'ہٹائیں',
      started: 'درآمد شدہ گفتگو ہٹائی جا رہی ہے۔',
      done: '{{conversations}} گفتگو اور {{contacts}} لوگ ہٹا دیے گئے۔',
      kept: '{{count}} ریکارڈ رکھے گئے کیونکہ وہ ابھی استعمال میں ہیں۔',
    },
  },
  export: {
    title: 'تاریخ برآمد کریں',
    description:
      'کسی برانڈ کی گفتگو Hamnivo پیکج کے طور پر ڈاؤن لوڈ کریں: وہی فارمیٹ جو درآمد میں استعمال ہوتا ہے۔',
    brand: 'برانڈ',
    submit: 'برآمد کریں',
    queued: 'برآمد شروع ہو گئی۔ تیار ہونے پر یہ فہرست میں نظر آئے گی۔',
    running: 'پیکج تیار ہو رہا ہے…',
    ready: 'پیکج تیار ہے',
    download: 'پیکج ڈاؤن لوڈ کریں',
    expired: 'پیکج 24 گھنٹے بعد مٹا دیا گیا۔ دوبارہ برآمد کریں۔',
    failed: 'برآمد ناکام رہی۔ دوبارہ کوشش کریں۔',
  },
};
